// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"75349199","314":"478fc575","385":"450020f9"}[chunkId] + ".js";
};